import { render, staticRenderFns } from "./PlayerIndexGame.vue?vue&type=template&id=58ba5902&"
import script from "./PlayerIndexGame.vue?vue&type=script&lang=js&"
export * from "./PlayerIndexGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports